import { PolicyComponentDetailsState } from "@idw-types/state/policy-component-details";
import { PolicyComponentDetailsActions, PolicyComponentDetailsActionTypes } from "@redux/actions/policy-component-details-actions";

export const initialPolicyComponentDetailsState: PolicyComponentDetailsState = {
    policyComponentDetails: {
        policyComponent: null,
        isLoading: false,
    },
    associatedPolicies: {
        isLoading: false,
        associatedPolicies: null
    }
}

export const policyComponentDetailsReducer = (
    state: PolicyComponentDetailsState = initialPolicyComponentDetailsState,
    action: PolicyComponentDetailsActions
): PolicyComponentDetailsState => {
    switch (action.type) {
        case PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_DETAILS_LOADING: {
            return {
                ...state,
                policyComponentDetails: {
                    ...state.policyComponentDetails,
                    isLoading: action.payload.isLoading
                }
            };
        }
        case PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_DETAILS: {
            return {
                ...state,
                policyComponentDetails: {
                    policyComponent: action.payload.policyComponent,
                    isLoading: false
                }
            };
        }
        case PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_ASSOCIATED_POLICIES_LOADING: {
            return {
                ...state,
                associatedPolicies: {
                    ...state.associatedPolicies,
                    isLoading: action.payload.isLoading
                }
            };
        }
        case PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_ASSOCIATED_POLICIES: {
            return {
                ...state,
                associatedPolicies: {
                    associatedPolicies: action.payload.associatedPolicies,
                    isLoading: false
                }
            };
        }
        default:
            return state;
    }
};